import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-377dd962"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "info-box" };
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "tip" };
var _hoisted_6 = { class: "menu" };
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("退出登录");
var _hoisted_8 = { class: "overlay-wrapper" };
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("样本编码查询中...");
import { ref } from "vue";
import { NavBar, Icon, Button, Cell, Toast, Dialog } from "vant";
import { requestUserInfo, logout, checkSample } from "@/api";
import { debounce } from "@/utils";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PersonalCenter',
    setup: function (__props) {
        var _this = this;
        var route = useRoute();
        var router = useRouter();
        var orderIcon = require("../../assets/my-orders.png");
        var aboutUsIcon = require("../../assets/about-us.png");
        var contactUsIcon = require("../../assets/contact-us.png");
        var headImgUrl = ref();
        var tel = ref("");
        var getUserInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestUserInfo()];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            tel.value = res.data.mobile;
                            headImgUrl.value = res.data.headImgUrl;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getUserInfo();
        var handleLogout = function () {
            Dialog.confirm({
                message: "确认退出登录？",
            })
                .then(function () {
                loading.value = true;
                var userType = localStorage.getItem("userType");
                logout();
                localStorage.clear();
                localStorage.setItem("userType", userType);
                router.push("/login");
            })
                .catch(function () {
                // on cancel
            });
        };
        var loadingVisible = ref(false);
        var scanCode = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                console.log(1);
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function (res) { return __awaiter(_this, void 0, void 0, function () {
                        var sampleCode, data;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    console.log(res.resultStr);
                                    sampleCode = (_a = res.resultStr) === null || _a === void 0 ? void 0 : _a.split(",")[1];
                                    return [4 /*yield*/, checkSample(sampleCode)];
                                case 1:
                                    data = _b.sent();
                                    if (data.code === 200) {
                                        router.push("/salesman-scan-out?sampleCode=" + sampleCode);
                                    }
                                    else {
                                        Toast(data.message);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    fail: function (err) {
                        Toast("网络错误-06");
                    },
                });
                return [2 /*return*/];
            });
        }); };
        var handleScan = debounce(scanCode, 300);
        var loading = ref(false);
        return function (_ctx, _cache) {
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), { title: "个人中心" }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24",
                            onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: headImgUrl.value ? require(headImgUrl.value) : require('../../assets/head.png'),
                            alt: ""
                        }, null, 8, _hoisted_4),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(tel.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(Cell), {
                            "is-link": "",
                            onClick: _unref(handleScan)
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_unref(Icon), {
                                    size: "0.4rem",
                                    name: _unref(orderIcon)
                                }, null, 8, ["name"])
                            ]; }),
                            title: _withCtx(function () { return [
                                _createElementVNode("span", {
                                    style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
                                }, "扫码出库 ", 4)
                            ]; }),
                            _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_unref(Cell), {
                            "is-link": "",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push('/salesman-sample-list')); })
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_unref(Icon), {
                                    size: "0.4rem",
                                    name: _unref(aboutUsIcon)
                                }, null, 8, ["name"])
                            ]; }),
                            title: _withCtx(function () { return [
                                _createElementVNode("span", {
                                    style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
                                }, "检测样本管理 ", 4)
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_unref(Cell), {
                            "is-link": "",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (_unref(router).push('/salesman-my-orders')); })
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_unref(Icon), {
                                    size: "0.4rem",
                                    name: _unref(contactUsIcon)
                                }, null, 8, ["name"])
                            ]; }),
                            title: _withCtx(function () { return [
                                _createElementVNode("span", {
                                    style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
                                }, "订单管理 ", 4)
                            ]; }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.code), 1),
                    _createVNode(_unref(Button), {
                        class: "submit-btn",
                        square: "",
                        onClick: handleLogout
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_7
                        ]; }),
                        _: 1
                    })
                ]),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_9
                                ]; }),
                                _: 1
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
